import React from 'react'
import Style from "./Style.module.css"


const Button = (props) => {

    
   
  
    return (
        <div>
            <button onClick={props.onClick} className={Style.buttonSuccess}>{props.children}</button>
        </div>
    )
}
const ButtonError=(props)=>{
    return(
        <div>
            <button onClick={props.onClick} className={Style.buttonError}>{props.children}</button>
        </div>
    )
}
const ButtonLogin=(props)=>{
    return(
        <div style={{display:"flex",justifyContent:"center",alignItem:"center"}}>
            <button onClick={props.onClick} className={Style.buttonLogin}>{props.children}</button>
        </div>
    )
}
const ButtonEdit=(props)=>{
    return(
        <div style={{display:"flex",justifyContent:"center",alignItem:"center"}}>
            <button onClick={props.onClick} className={Style.buttonEdit}>{props.children}</button>
        </div>
    )
}
export{ Button ,ButtonError,ButtonLogin,ButtonEdit}
